import { ZfTooltip } from '@zafire/react';
import React from 'react';

type Props = {
  reasons: string[];
  anchorEl: HTMLElement | null;
};

export const SaveBlockedTooltip: React.FC<Props> = ({ reasons, anchorEl }) => {
  if (!reasons.length || !anchorEl) return null;

  return (
    <ZfTooltip anchor={() => anchorEl} side="top" contentAlignment="start">
      {reasons.map((reason) => (
        <div key={reason}>{reason}</div>
      ))}
    </ZfTooltip>
  );
};
